import { band } from '../lib/results';

/**
 * A band, coloured the way a teacher's eye already sorts them: still a long
 * way to go, getting there, ready for most universities, strong.
 *
 * The colour carries no information the number does not — it lets a teacher
 * run down a column of thirty and see who needs them without reading every
 * one. A paper still waiting for its examiner has no band, and says so.
 */
export function bandTier(value: number): 'low' | 'mid' | 'good' | 'high' {
  if (value < 4) return 'low';
  if (value < 6) return 'mid';
  if (value < 7) return 'good';
  return 'high';
}

export function Band({ value, size = 'md' }: { value: number | null; size?: 'md' | 'lg' }) {
  if (value === null) {
    return (
      <span className={`band band--pending band--${size}`} title="Waiting for an examiner">
        —
      </span>
    );
  }
  return <span className={`band band--${bandTier(value)} band--${size}`}>{band(value)}</span>;
}
